import classNames from "classnames";
import { CopyableText } from "components/CopyableText/CopyableText";
import { Button } from "components/DesignSystem/Button/Button";
import { Cross } from "components/icons/Cross";
import { Inkle } from "components/icons/Logos/Inkle";
import { WavyArrowRight } from "components/icons/WavyArrowRight";
import { SUPPORT_EMAIL } from "constants/base";
import {
  SIGNIN_SOURCE_FINALLY,
  SIGNIN_SOURCE_QUERY,
} from "constants/magicLink";
import { FINALLY_MIGRATION_BANNER_DISMISSED_KEY } from "constants/storageKeys";
import { useLocalStorage } from "hooks/useLocalStorage";
import { useQuery } from "hooks/useQuery";

const BADGE_PILL_CLASS =
  "t-flex t-h-6 t-w-16 t-items-center t-justify-center t-rounded-full t-bg-white";

const MigrationBadge = () => (
  <div className="t-flex t-shrink-0 t-items-center t-gap-1">
    <span
      className={classNames(
        BADGE_PILL_CLASS,
        "t-text-subtitle-sm t-font-bold t-text-text-100"
      )}
    >
      finally
    </span>
    <WavyArrowRight className="t-text-purple" />
    <span className={BADGE_PILL_CLASS}>
      <Inkle width="36" height="14" />
    </span>
  </div>
);

export const FinallyMigrationBanner = () => {
  const query = useQuery();
  const { localData: isDismissed, setItem } = useLocalStorage(
    FINALLY_MIGRATION_BANNER_DISMISSED_KEY,
    false
  );

  const isFromFinally =
    query.get(SIGNIN_SOURCE_QUERY) === SIGNIN_SOURCE_FINALLY;

  const handleDismiss = () => setItem(true);

  if (!isFromFinally || isDismissed) {
    return null;
  }

  return (
    <div className="t-relative t-z-10 t-flex t-w-full t-items-center t-gap-5 t-bg-linear-gradient-purple t-px-8 t-py-4 sm:t-flex-col sm:t-items-start sm:t-gap-3 sm:t-px-4">
      <MigrationBadge />
      <p className="t-m-0 t-flex-1 t-text-body-sm t-text-text-60">
        Finally’s bookkeeping is now part of Inkle. Your bookkeeping data has
        been securely migrated to Inkle. Use your work email to access your
        account. Contact <CopyableText value={SUPPORT_EMAIL} /> if you need
        help.{" "}
      </p>
      <Button
        customType="ghost_icon"
        size="small"
        onClick={handleDismiss}
        aria-label="Dismiss banner"
        className="sm:t-absolute sm:t-right-2 sm:t-top-2"
      >
        <Cross />
      </Button>
    </div>
  );
};
